import { defaultStatus } from '@/_schemas/status-input';
import type { RouteListItem } from '@/types';

import { type MagazineFormSchema } from './schemas';

import { settingsBcLink } from '../../model';

export const defaultValues: Readonly<MagazineFormSchema> = {
  id: -1,
  name: '',
  website: '',
  status: defaultStatus,
} as const;

export const breadcrumbsLinks: RouteListItem[] = [settingsBcLink, { path: '/settings/magazines', name: 'Magazines' }];
